import React, {Component} from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import lessonLayout from "./lessonLayout.module.css"
import {trackCustomEvent} from "gatsby-plugin-google-analytics"

import LessonHeader from "./newLessonHeader"
import TOC from "./toc"
import Footer from "./newFooter"
import Feedback from "./feedback"
import MobileFeedback from "./mobileFeedback"

export const data = graphql`
  query TitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

class Lesson extends Component {
    constructor(props) {
        super(props);

        this.state = {
            revealMobileFeedback: false,
        }
    }

    componentDidMount() {
        const lessonName = this.props.name;
        window.onerror = function(message, source, lineno, colno, error) {
            if (error) message = error.stack;
            trackCustomEvent({
                category: `error-${lessonName}`,
                action: message,
                label: navigator.userAgent,
            });
        }
    }

    toggleMobileFeedback = () => this.setState({revealMobileFeedback: !this.state.revealMobileFeedback});

    render() {
        const mobileFeedbackStyle = {
            display: this.state.revealMobileFeedback ? 'block': 'none',
            opacity: this.state.revealMobileFeedback ? 1 : 0,
            transition: "all 1s ease",
        }

        return (
            <div className={this.props.tocData ? lessonLayout.gridContainer : lessonLayout.gridContainerNOTOC}>

              <LessonHeader location={this.props.location} name={this.props.name} tocData={this.props.tocData} toggleMobileFeedback={this.toggleMobileFeedback} />

              <div className={this.props.cardLayout ? lessonLayout.mainCard : lessonLayout.main}>
                <main style={{overflowY: "hidden"}}>
                    {this.props.children}
                    { this.props.cardLayout
                        ?
                            <div className={lessonLayout.mobileOnly} style={{margin:"3rem auto 1rem", width:"max-content"}}>
                                <div style={{
                                        display:"grid",
                                        gridTemplateColumns:"auto auto",
                                        gridGap:"5px",
                                        placeItems:"center",
                                        justifyContent:"center",
                                        width:"max-content",
                                        margin:"0 auto",
                                        fontFamily:"Poppins-Medium",
                                        fontSize:"18px",
                                        cursor:"pointer",
                                        padding:"10px 20px",
                                        borderRadius: "30px",
                                        border: "1px solid rgb(240, 241, 242)",
                                        boxShadow: "2px 2px 2px rgba(0, 0, 25, 0.075)",
                                  }} onClick={this.toggleMobileFeedback}>
                                    <div><div style={{transform:"translateY(1px)"}}><i class={"ri-chat-3-line"}></i></div></div>
                                    <div>Leave Feedback</div>
                                </div>
                            </div>
                        :
                            null
                    }
                </main>
              </div>
              <div className={lessonLayout.footer}>
                <Footer />
              </div>
              { this.props.tocData
                  ?
                    <>
                      <div className={lessonLayout.mobileOnly} style={mobileFeedbackStyle}>
                        <MobileFeedback name={this.props.name} tocData={this.props.tocData} toggleMobileFeedback={this.toggleMobileFeedback} />
                      </div>
                    </>
                  : <Feedback name={this.props.name} />
              }
            </div>
        );
    }
}

Lesson.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Lesson
